import type { FC } from 'react';

import { cn } from '@/shared/libs';

import { CountryFlag } from './CountryFlag';

export interface CountryCodesProps {
  className?: string;
  codes: readonly string[];
}

export const CountryCodes: FC<CountryCodesProps> = ({ className, codes }) => {
  if (codes.length === 0) {
    return <>—</>;
  }

  return (
    <span
      className={cn(
        'inline-flex flex-wrap items-center gap-x-2 gap-y-1',
        className,
      )}>
      {codes.map((code) => (
        <span key={code} className="inline-flex items-center gap-1">
          <CountryFlag code={code} />
          {code}
        </span>
      ))}
    </span>
  );
};

CountryCodes.displayName = 'CountryCodes';
